import { Link } from 'react-router-dom';
import LegalDoc from '../components/LegalDoc';
import {
  HOSTING_DC_ADDRESS,
  HOSTING_INN,
  HOSTING_LEGAL_ADDRESS,
  HOSTING_NAME,
  HOSTING_OGRN,
  OFERTA_PATH,
  OPERATOR_EMAIL,
  OPERATOR_INN,
  OPERATOR_NAME,
  OPERATOR_OGRNIP,
  OPERATOR_OGRNIP_DATE,
  OPERATOR_PHONE,
  OPERATOR_REGION,
  POLICY_DATE,
  PROCESSING_START_DATE,
  SITES_LABEL,
} from '../legal/operator';

export default function PrivacyPage() {
  return (
    <LegalDoc title="Политика обработки персональных данных">
      <p>
        Настоящая Политика определяет порядок обработки и защиты персональных данных
        пользователей сайтов {SITES_LABEL} (далее — Сайт) в соответствии с Федеральным
        законом от 27.07.2006 № 152-ФЗ «О персональных данных».
      </p>
      <p>
        Актуальная редакция: {POLICY_DATE}. Дата начала обработки:{' '}
        {PROCESSING_START_DATE} (как в уведомлении оператора в Роскомнадзор,
        № 100389645).
      </p>

      <h2>1. Оператор</h2>
      <p>
        Оператор персональных данных: {OPERATOR_NAME}.
      </p>
      <ul>
        <li>ИНН: {OPERATOR_INN}</li>
        <li>
          ОГРНИП: {OPERATOR_OGRNIP} (дата присвоения {OPERATOR_OGRNIP_DATE})
        </li>
        <li>Регион регистрации: {OPERATOR_REGION}</li>
        <li>
          Электронная почта для запросов субъектов ПДн:{' '}
          <a href={`mailto:${OPERATOR_EMAIL}`}>{OPERATOR_EMAIL}</a>
        </li>
        <li>Телефон: {OPERATOR_PHONE}</li>
      </ul>
      <p>
        Обработка ведётся на территории всех субъектов Российской Федерации
        (дистанционные услуги). Почтовый адрес для запросов на бумаге не
        публикуется на Сайте: направляйте обращения на указанную электронную
        почту. Ответ направляется на адрес, с которого получен запрос, либо на
        email учётной записи.
      </p>

      <h2>2. Категории субъектов</h2>
      <p>
        Обрабатываются персональные данные клиентов (учеников и их законных
        представителей, пользователей личного кабинета) и посетителей Сайта.
      </p>

      <h2>3. Какие данные обрабатываются</h2>
      <p>
        В уведомлении Роскомнадзора указаны фамилия, имя, отчество и адрес
        электронной почты. На Сайте, в зависимости от того, чем вы пользуетесь,
        могут обрабатываться также сведения ниже. Они нужны для договора на
        обучение, входа в кабинет и работы Сайта.
      </p>
      <h3>3.1. Регистрация и вход</h3>
      <ul>
        <li>фамилия, имя, отчество (имя — в форме регистрации; фамилия и отчество — в профиле, по желанию);</li>
        <li>адрес электронной почты;</li>
        <li>имя пользователя (логин);</li>
        <li>пароль (хранится в виде криптографического хеша, не в открытом виде);</li>
        <li>предпочтительный канал связи (email, «Макс», телефон);</li>
        <li>факт и дата согласия на обработку персональных данных.</li>
      </ul>
      <h3>3.2. Профиль (заполняете сами, не обязательно для входа)</h3>
      <ul>
        <li>телефон;</li>
        <li>город, школа, класс;</li>
        <li>роль на Сайте (ученик, родитель, преподаватель);</li>
        <li>аватар, если загружен;</li>
        <li>настройки редактора кода.</li>
      </ul>
      <h3>3.3. Анкета ученика</h3>
      <ul>
        <li>цель подготовки (ОГЭ / ЕГЭ и год сдачи);</li>
        <li>целевые баллы;</li>
        <li>отношение к домашним заданиям и загруженность;</li>
        <li>отношение к групповым занятиям;</li>
        <li>сведения о финансовых возможностях семьи;</li>
        <li>свободный комментарий.</li>
      </ul>
      <h3>3.4. Обучение</h3>
      <ul>
        <li>решения задач (код, статус проверки, самооценка, комментарии);</li>
        <li>прогресс, списки заданий, журнал занятий;</li>
        <li>
          сведения о присутствии на странице работы (какая задача открыта, время
          последней активности) — чтобы преподаватель видел ход занятия;
        </li>
        <li>содержимое совместного редактора и состав участников сессии;</li>
        <li>сообщения в обсуждениях задач, если вы их пишете.</li>
      </ul>
      <h3>3.5. Оплата</h3>
      <ul>
        <li>сумма и статус платежа;</li>
        <li>email для чека;</li>
        <li>идентификаторы платежа в Озон Пай;</li>
        <li>состав семейного счёта (кто к нему привязан).</li>
      </ul>
      <h3>3.6. Технические данные посетителя Сайта</h3>
      <ul>
        <li>файлы cookie сессии и защиты форм (см. раздел 7);</li>
        <li>
          IP-адрес, сведения о браузере и запросах — в журналах веб-сервера в объёме,
          необходимом для безопасности и диагностики.
        </li>
      </ul>

      <h2>4. Цели обработки</h2>
      <p>
        Цель обработки, указанная в уведомлении Роскомнадзора: подготовка,
        заключение и исполнение гражданско-правового договора.
      </p>
      <p>На Сайте это включает:</p>
      <ul>
        <li>регистрацию, вход и ведение учётной записи;</li>
        <li>
          оказание услуг по подготовке к ОГЭ/ЕГЭ по{' '}
          <Link to={OFERTA_PATH}>договору-оферте</Link>
          : занятия, задания, проверка кода, журнал, связь преподавателя с учеником;
        </li>
        <li>
          анкету — чтобы преподаватель подобрал формат занятий; не нужна для самого
          входа на Сайт;
        </li>
        <li>приём оплаты и учёт баланса;</li>
        <li>обеспечение работы и безопасности Сайта;</li>
        <li>исполнение требований законодательства РФ (в том числе учёт расчётов).</li>
      </ul>

      <h2>5. Правовые основания</h2>
      <p>Обработка осуществляется:</p>
      <ul>
        <li>
          на основании{' '}
          <Link to="/consent">согласия</Link> субъекта персональных данных;
        </li>
        <li>
          для исполнения{' '}
          <Link to={OFERTA_PATH}>гражданско-правового договора (оферты)</Link>
          {' '}— учётная запись, обучение, оплата, связь по выбранному каналу;
        </li>
        <li>
          для осуществления и выполнения обязанностей, возложенных на оператора
          законодательством Российской Федерации.
        </li>
      </ul>

      <h2>6. Действия и способы</h2>
      <p>
        Сбор, запись, систематизация, накопление, хранение, уточнение (обновление,
        изменение), извлечение, использование, передача (предоставление) лицам из
        раздела 8, блокирование, удаление, уничтожение.
      </p>
      <p>
        Способы: автоматизированная обработка; с передачей по сети Интернет;
        без передачи по внутренней сети юридического лица (оператор — индивидуальный
        предприниматель, внутренней сети организации нет).
      </p>
      <p>
        Обезличивание персональных данных не применяется.
      </p>

      <h2>7. Cookie и локальные данные браузера</h2>
      <p>
        Сайт использует только необходимые cookie: идентификатор сессии (вход) и
        токен защиты форм (CSRF). Без них личный кабинет не работает. Аналитических
        и рекламных cookie, Яндекс.Метрики и Google Analytics нет. При первом
        посещении показывается уведомление; необходимые cookie ставятся и до нажатия
        «Понятно», иначе нельзя войти.
      </p>
      <p>
        В localStorage браузера могут сохраняться тема оформления и черновики
        редактора — это остаётся на вашем устройстве, пока вы сами не очистите данные
        сайта.
      </p>
      <p>
        Отключить cookie можно в настройках браузера; вход и отправка форм при этом
        перестанут работать.
      </p>

      <h2>8. Передача третьим лицам</h2>
      <p>Данные не продаются. Передаются только тем, без кого Сайт не работает:</p>
      <ul>
        <li>
          хостинг {HOSTING_NAME} (ИНН {HOSTING_INN}, ОГРН {HOSTING_OGRN}): база
          данных граждан РФ размещена в ЦОД по адресу {HOSTING_DC_ADDRESS};
          адрес организации: {HOSTING_LEGAL_ADDRESS}. Собственного ЦОД у оператора
          нет;
        </li>
        <li>
          Озон Пай — при пополнении баланса (email для чека, сумма, назначение
          платежа);
        </li>
        <li>
          почтовый сервис (как правило, Яндекс) — письма о регистрации и анкете
          преподавателю;
        </li>
        <li>
          «Макс» или ВКонтакте — только если вы сами указали этот канал и контакт.
        </li>
      </ul>
      <p>
        CRM-система и отдельный сервис облачного хранения к обработке не привлекаются.
        Также данные могут быть предоставлены по законному требованию государственных
        органов РФ.
      </p>

      <h2>9. Место, срок и прекращение обработки</h2>
      <p>
        Первичный сбор, запись и хранение персональных данных граждан РФ выполняются
        на серверах на территории Российской Федерации (ЦОД {HOSTING_NAME}, Москва).
      </p>
      <p>
        Обработка прекращается при отзыве согласия субъектом либо при достижении
        целей обработки, если более длительный срок не установлен законом
        (например, сведения об оплате). Данные учётной записи хранятся, пока она
        действует, либо до требования об удалении. Резервные копии базы создаются
        на том же хостинге и уничтожаются по мере ротации.
      </p>
      <p>
        Трансграничная передача персональных данных не осуществляется: скрипты,
        шрифты и среда Python для запуска кода в браузере размещены на Сайте
        (серверы в РФ). Связь — через сервисы на территории РФ (почта Яндекса,
        «Макс», ВКонтакте) либо по телефону.
      </p>

      <h2>10. Меры защиты</h2>
      <p>
        Обработку веду лично я как оператор. Доступ к базе и административным
        функциям Сайта имею только я. Применяются: парольная защита устройств,
        антивирусное программное обеспечение, протокол HTTPS, резервное копирование
        базы на хостинге, ограничение доступа посторонних лиц к рабочему компьютеру.
        Сертифицированные средства криптографической защиты информации (СКЗИ) не
        используются; соединение с Сайтом защищается протоколом HTTPS.
      </p>
      <p>
        Ответственный за организацию обработки персональных данных — оператор
        ({OPERATOR_NAME}).
      </p>

      <h2>11. Права пользователя</h2>
      <p>
        Вы вправе запросить доступ, уточнение, блокирование или удаление своих
        персональных данных, а также отозвать согласие. Для этого напишите на{' '}
        <a href={`mailto:${OPERATOR_EMAIL}`}>{OPERATOR_EMAIL}</a>
        {' '}с адреса, указанного в профиле, либо приложите данные, по которым можно
        опознать учётную запись.
      </p>
      <p>
        Факт согласия при регистрации фиксируется: время, IP-адрес, версия текста
        согласия. Часть сведений можно изменить самостоятельно в разделе «Профиль».
        Удаление аккаунта по кнопке на Сайте пока не сделано: запрос выполняется по
        почте.
      </p>

      <h2>12. Несовершеннолетние</h2>
      <p>
        Сайт используется для подготовки школьников к ОГЭ и ЕГЭ. Если вам нет 18 лет,
        согласие на обработку персональных данных даёт законный представитель.
        Регистрируясь, вы подтверждаете, что вам есть 18 лет либо законный
        представитель дал согласие на использование Сайта.
      </p>

      <h2>13. Изменения политики</h2>
      <p>
        Актуальная редакция всегда доступна на этой странице. Дата редакции указана
        в начале документа.
      </p>
    </LegalDoc>
  );
}
